'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * if-user-tasks-status="RUNNING" = PENDING,STARTED, IN_PROGRESS
 * vous pouvez aussi indiquer ERROR, COMPLETED
 */
ngModule.directive('ifUserTask', function (userTaskService, $animate, directiveUtils) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      userTaskService.loadTasksIfRequired();
      var taskType = $attrs.ifUserTask;
      var taskStatus = $attrs.ifUserTaskStatus;
      var conditionFn = function conditionFn() {
        var tasks = userTaskService.getCurrentTasks();
        if (taskType) {
          tasks = _.filter(tasks, {
            type: taskType
          });
        }
        if (taskStatus) {
          if (taskStatus === 'RUNNING') {
            tasks = _.filter(tasks, function (t) {
              return t.status === 'PENDING' || t.status === 'STARTED' || t.status === 'IN_PROGRESS';
            });
          } else {
            tasks = _.filter(tasks, function (t) {
              return t.status === taskStatus;
            });
          }
        }
        return tasks.length > 0;
      };
      var conditionalTransclude = directiveUtils.createNgIfTranscludeWatchFn($element, $transclude);
      $scope.$watch(conditionFn, conditionalTransclude);
    }
  };
});

/**
 * if-user-tasks-status="RUNNING" = PENDING,STARTED, IN_PROGRESS
 * vous pouvez aussi indiquer ERROR, COMPLETED
 */

ngModule.directive('ifNoUserTask', function (userTaskService, $animate, directiveUtils) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      userTaskService.loadTasksIfRequired();
      var taskType = $attrs.ifNoUserTask;
      var taskStatus = $attrs.ifUserTaskStatus;
      var conditionFn = function conditionFn() {
        var tasks = userTaskService.getCurrentTasks();
        if (taskType) {
          tasks = _.filter(tasks, {
            type: taskType
          });
        }
        if (taskStatus) {
          if (taskStatus === 'RUNNING') {
            tasks = _.filter(tasks, function (t) {
              return t.status === 'PENDING' || t.status === 'STARTED' || t.status === 'IN_PROGRESS';
            });
          } else {
            tasks = _.filter(tasks, function (t) {
              return t.status === taskStatus;
            });
          }
        }
        return tasks.length === 0;
      };
      var conditionalTransclude = directiveUtils.createNgIfTranscludeWatchFn($element, $transclude);
      $scope.$watch(conditionFn, conditionalTransclude);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/user-task/ifUserTask.js
// module id = 2881
// module chunks = 13